module.exports = __webpack_public_path__ + "static/media/a54.288d5075.jpg";